import { map, reject, propEq, either, isEmpty, propSatisfies, none, all } from 'ramda'
import * as types from 'store/surveyErrors/surveyErrorsTypes'

const initialState = {
  questionErrors: {},
  surveyErrors: [],
  displayAllErrors: false,
}

const questionErrorsFromPayload = questions => map(
  ({id, title, validationErrors}) => ({id, label: `${title}: ${validationErrors.join(', ')}`}),
  reject(either(propEq('typeId', 13), propSatisfies(isEmpty, 'validationErrors')), (questions))
)

const surveyErrors = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ALL_NECESSARY_PROJECT_INFO_SUCCEEDED:
      return {
        ...state,
        // displayAllErrors:
        //   none(propSatisfies(either(propEq('status', 1), propEq('status', 2)), 'status'), action.payload.surveys) &&
        //   !all(propSatisfies(isEmpty, 'validationErrors'), action.payload.surveyErrors),
        // surveyErrors: reject(propSatisfies(isEmpty, 'validationErrors'), (action.payload.surveyErrors)),
      }
    case types.FETCH_QUESTIONS_SUCCEEDED: {
      return {
        ...state,
        questionErrors: {
          [action.payload.json.surveyId]: questionErrorsFromPayload(action.payload.json.questions),
        },
      }
    }
    case types.DELETE_QUESTION_SUCCEEDED: {
      return {
        ...state,
        questionErrors: {
          ...state.questionErrors,
          [action.payload.meta.surveyId]:
            state.questionErrors[action.payload.meta.surveyId].filter(
              ({id}) => id !== action.payload.meta.questionId
            ),
        },
      }
    }
    default:
      return state
  }
}

export default surveyErrors
